export default __webpack_public_path__ + "static/media/red.8f1dca2a.svg";